import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiService } from '../base-api.service';
import { catchError, Observable, throwError } from 'rxjs';
import { RS_FISKALNI_DEFAULT } from 'src/app/_constants/appMessages';

@Injectable({
  providedIn: 'root'
})
export class PrintRsService {
  defaultFiskalni = JSON.parse(localStorage.getItem(RS_FISKALNI_DEFAULT)) || {};

  constructor(private httpClient: HttpClient, private api: BaseApiService) { }

  baseUri = this.defaultFiskalni?.url // "http://10.40.40.35:3566/api/";

  getStatus() {
    return this.httpClient.get(this.baseUri + 'status', { headers: this.getHeaders() });
  }

  sendInvoice(invoice): Observable<any> {
    return this.httpClient.post(this.baseUri + 'invoices', invoice, { headers: this.getHeaders() });
  }

  searchInvoices(params): Observable<any> {
    return this.httpClient.post(this.baseUri + 'invoices/search', params, { headers: this.getHeaders() })
      .pipe(catchError(this.handleError<[]>('amortizacije/delete')));
  }

  getAttention(): Observable<any> {
    return this.httpClient.get(this.baseUri + 'attention', { headers: this.getHeaders() })
      .pipe(catchError(this.handleError<[]>('amortizacije/delete')));
  }

  probniGotovinskiRacun() {
    var body = {
      print: false,
      invoiceRequest: {
        invoiceType: 'Normal',
        transactionType: "Sale",
        payment: [{
          amount: 100.00,
          paymentType: "Cash"
        }],
        items: [{
          name: "Artikl 1",
          labels: [
            "F"
          ],
          totalAmount: 100.00,
          unitPrice: 50.00,
          quantity: 2.000
        }],
        cashier: "Radnik 1"
      }
    }
    return this.httpClient.post(this.baseUri + 'invoices', body, { headers: this.getHeaders() });
  }

  private getHeaders(): HttpHeaders {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    //let auth = JSON.parse(localStorage.getItem(MonriAuthKey));

    // if (auth) {
    headers = headers.append('Authorization', 'Bearer ' + this.defaultFiskalni.key);
    //  }
    return headers;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      const errorMsg = `${operation} failed: ${error.message}`;

      return throwError(error);
    };
  }
}
